import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {modulesRequest, visibleModules} from './userModulesApi';
import './UserModules.scss';

const UserModules = ({userId}) => {
    const t = useSelector(state => state.language.translator);
    const [modules, setModules] = useState(null);
    const [error, setError] = useState('');
    const [saving, setSaving] = useState('');

    useEffect(() => {
        let cancelled = false;
        modulesRequest(`/modules/moduleListForUser?userId=${userId}`)
            .then(list => !cancelled && setModules(visibleModules(list)))
            .catch(() => !cancelled && setError(t.gettext('Could not load modules.')));
        return () => {
            cancelled = true;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userId]);

    const save = async (key, path) => {
        setError('');
        setSaving(key);
        try {
            setModules(visibleModules(await modulesRequest(path, 'POST')));
        } catch (e) {
            setError(t.gettext('Could not save the module change.'));
        } finally {
            setSaving('');
        }
    };
    const toggleActive = module => save(module.moduleType,
        `/modules/${module.active ? 'deactivateModule' : 'activateModule'}?moduleType=${module.moduleType}&userId=${userId}`);
    const togglePaid = module => save(`${module.moduleType}-paid`,
        `/modules/setModulePaid?moduleType=${module.moduleType}&userId=${userId}&paid=${!module.paid}`);

    if (!modules) {
        return <div className='userModules'>
            {error ? <p className='userModulesError' role='alert'>{error}</p> : <p>{t.gettext('Loading…')}</p>}
        </div>;
    }
    return <div className='userModules'>
        <p className='userModulesHint'>{t.gettext('Modules decide which features this user sees in the apps.')}</p>
        {error && <p className='userModulesError' role='alert'>{error}</p>}
        <ul>
            {modules.map(module => <li key={module.moduleType}>
                <div className='userModulesRow'>
                    <div>
                        <label htmlFor={`module-${module.moduleType}`} className='userModulesName'>{t.gettext(module.name)}</label>
                        {module.description && <div className='userModulesDescription'>{t.gettext(module.description)}</div>}
                    </div>
                    <input type='checkbox' role='switch' id={`module-${module.moduleType}`} checked={module.active}
                           disabled={saving === module.moduleType} onChange={() => toggleActive(module)}/>
                </div>
                {module.hasPaid && <div className='userModulesRow userModulesSub'>
                    <label htmlFor={`module-${module.moduleType}-paid`}>{t.gettext('Paid: live data and frost alerts')}</label>
                    <input type='checkbox' role='switch' id={`module-${module.moduleType}-paid`} checked={module.paid}
                           disabled={!module.active || saving === `${module.moduleType}-paid`}
                           onChange={() => togglePaid(module)}/>
                </div>}
            </li>)}
        </ul>
    </div>;
};

export default UserModules;
